var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodreads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Goodreads",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#ece9d4",
    rx: "15%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#814910",
    d: "M380 73h-35v37c-54-75-165-51-196 23-20 48-19 96 2 144 22 50 85 71 135 57 16-3 32-11 43-21 6-5 12-10 16-15-1 19-2 38-5 56-4 23-14 43-36 54-48 25-105 6-126-43h-33c2 32 19 53 46 66 32 16 66 18 100 12 44-7 73-32 83-76 4-16 5-32 6-48 .9-90-.2-173 .2-246zm-40 178c-6 18-17 32-31 42-3 2-20 14-45 15-1 .1-6 .2-11 0-.2.1-.3.1-.6.1-36-2-63-23-75-58-10-29-10-59-3-88 11-43 42-69 81-70 .9-.1 1-.1 1-.1 20-2 36 7 42 9 21 11 37 32 44 61 7 30 8 60-2 89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodreads);
export default __webpack_public_path__ + "static/media/goodreads.b74d2e40aebc0b27d0db0c6130f5df82.svg";
export { ForwardRef as ReactComponent };